export type ProposalCustomerLink={id:string;status:string;url:string|null;published_version:number|null};
/** An authenticated, non-cached read, independent of this browser's storage. */
export async function proposalCustomerLink(id:string,deps:{apiBase:string;headers:()=>Promise<Record<string,string>>;fetch:typeof fetch},signal?:AbortSignal):Promise<ProposalCustomerLink>{
 const r=await deps.fetch(`${deps.apiBase}/api/proposals/${encodeURIComponent(id.toLowerCase())}/private-link`,{headers:await deps.headers(),cache:'no-store',signal});const b=await r.json();
 if(!r.ok||!b.data||b.data.id!==id.toLowerCase())throw Error('Customer Proposal link unavailable');
 return b.data;
}
export function proposalLinkTarget(href:string|undefined):{id?:string;lead_id?:string;job_ref?:string}|null{
 if(!href)return null;const u=new URL(href,'https://crm.artemisflooring.com');
 const match=/^\/proposals\/([a-f0-9-]{36})$/i.exec(u.pathname);if(match)return {id:match[1]};
 if(u.pathname!=='/proposals/new')return null;
 const lead=u.searchParams.get('lead_id'),job=u.searchParams.get('job_ref');return lead?{lead_id:lead}:job?{job_ref:job}:null;
}
